export const totalPsoCounts = {
  total: 73,
  NO: 51,
  DK: 0,
  SE: 12,
  FI: 8,
  IS: 6,
  FO: 0,
  GL: 1,
};

export const existingRoutesCount = {
  total: 172,
  DK: 12,
  NO: 101,
  SE: 32,
  FI: 16,
  GL: 15,
  IS: 10,
  FO: 0,
};
